module.exports = __webpack_public_path__ + "img/zh_cn2.2e0fd9e9.png";